import { Component, inject } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import {
	TimeSelectedEvent,
	TimeSelectorComponent,
} from '@ui/Components/Form/TimeSelector/TimeSelector.Component'
import { RaisedButtonComponent } from '@ui/Components/Form/Button/RaisedButton.Component'

interface Time {
	hour: number
	minute: number
}

@Component({
	selector: 'time-picker-dialog',
	templateUrl: './TimePickerModal.Component.html',
	imports: [TimeSelectorComponent, RaisedButtonComponent],
})
export class TimePickerDialogComponent {
	public hour = 9
	public minute = 0

	public time: Time = {
		hour: 9,
		minute: 0,
	}

	private readonly dialogRef: MatDialogRef<TimePickerDialogComponent>

	constructor() {
		this.dialogRef = inject(MatDialogRef<TimePickerDialogComponent>)
	}

	public closeDialog = () => {
		this.dialogRef.close(this.time)
	}

	public setTime = (time: TimeSelectedEvent) => {
		this.time = {
			hour: parseInt(time.hour, 10),
			minute: parseInt(time.minute, 10),
		}
	}
}
